import * as types from '../constants/ActionTypes';
export const initialState = {};
export default (state = initialState, action) => {
    switch (action.type) {
        case types.UPDATE_ACTIVE_BRANCH:
            return { [action.payload.repositoryId]: action.payload.activeBranch };
        case types.CLEAR_ACTIVE_BRANCH:
            return {};
        default:
            return state;
    }
};
